import { render, staticRenderFns } from "./ModalPlansApartmens.vue?vue&type=template&id=2437d210&scoped=true&"
import script from "./ModalPlansApartmens.vue?vue&type=script&lang=js&"
export * from "./ModalPlansApartmens.vue?vue&type=script&lang=js&"
import style0 from "./ModalPlansApartmens.vue?vue&type=style&index=0&id=2437d210&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2437d210",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2437d210')) {
      api.createRecord('2437d210', component.options)
    } else {
      api.reload('2437d210', component.options)
    }
    module.hot.accept("./ModalPlansApartmens.vue?vue&type=template&id=2437d210&scoped=true&", function () {
      api.rerender('2437d210', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/ModalPlansApartmens.vue"
export default component.exports